import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const Image = require('../../../../../assets/img/timeline/modal/2017-office.jpg');

const RelocateContent = () => {
    return (
        <>
            <TimelineFullImage image={Image} />
            <h4>
                The BCT relocates offices
            </h4>
            <p>
                Breast Cancer Trials relocates offices, bringing our research, business and fundraising departments together at Scott Street, Newcastle.
            </p>
        </>
    );
}

export default RelocateContent;